<template>
    <div>
        <section>
            <section class="section">
                <div class="container is-fluid">
                    <h3 class="title">{{ $t("notifications.title") }}</h3>
                </div>
            </section>

            <section class="section">
                <div class="container is-fluid">
                    <h3 class="title">{{ $t("notifications.trackedUnits") }}</h3>
                    <p>{{ $t("notifications.trackedUnitsSubtitle") }}</p><br />

                    <NotificationRow v-for="(notification, index) in this.notifications" :key="index"
                        :notification="notification" @delete-notification="deleteNotification"
                        @disable-notification="disableNotificaion" @enable-notification="enableNotification"
                        @update-notification="updateNotification" @refresh-notification="refreshNotification" />
                </div>
            </section>

            <section class="section">
                <div class="container is-fluid">
                    <h3 class="title">{{ $t("notifications.untrackedUnits") }}</h3>

                    <CreateNotificationRow v-for="(notification, index) in this.creatableNotifications" :key="index"
                        :notification="notification" @add-notification="addNotification" />
                </div>
            </section>
        </section>
    </div>
</template>

<script>

const axios = require('axios');

import errorCodes from "@/assets/errors.js"
import NotificationRow from "@/components/notification/NotificationRow.vue"
import CreateNotificationRow from "@/components/notification/CreateNotificationRow.vue"

import { formatUnitName } from "@/utils/format";

export default {
    name: "Notifications",
    components: {
        NotificationRow,
        CreateNotificationRow
    },
    data: function () {
        return {
            notifications: [],
            creatableNotifications: [],
            api: axios.create({
                baseURL: process.env.VUE_APP_JOBS_API_ROOT,
                headers: { Authorization: `Bearer ${localStorage.backendToken}` }
            })
        }
    },
    methods: {
        fetchNotifications() {
            let view = this;

            this.api.get("notifications").then(function (response) {
                view.notifications = response.data.notifications.existing;
                view.creatableNotifications = response.data.notifications.creatable;
            }).catch(function () {
                view.$buefy.toast.open({
                    message: view.$t("notifications.loadingError"),
                    type: 'is-danger'
                })
            });
        },
        removeUntrackedUnit(unitId) {
            this.creatableNotifications = this.creatableNotifications.filter(notification => {
                return notification.unit.id != unitId;
            });
        },
        addNotification(notification, trigger) {
            let view = this;
            let unit = notification.unit;

            // Validate trigger
            if (trigger == null || trigger.replace(" ", "").length == 0 || isNaN(trigger)) {
                // The trigger is not numeric
                this.$buefy.toast.open({
                    message: this.$t("notifications.triggerNumberError"),
                    type: 'is-danger'
                });

                return;
            } else if (trigger > 500 || trigger <= 0) {
                // The trigger has an invalid value
                this.$buefy.toast.open({
                    message: this.$t("notifications.triggerBoundsError"),
                    type: 'is-danger',
                    duration: 3000
                });

                return;
            }

            let notificationData = {
                trigger: parseInt(trigger, 10),
                unit: {
                    brand: unit.brand,
                    model: unit.model,
                    year: unit.year,
                    name: unit.name,
                    id: unit.id
                }
            }

            this.api.post("create-notification", notificationData)
                .then(function (response) {
                    if (response.status == 200) {
                        view.$buefy.toast.open({
                            message: view.$t("notifications.saved"),
                            type: 'is-success'
                        })

                        notificationData.status = 'active'
                        notificationData.id = response.data.id;
                        notificationData.lastReading = 0;
                        notificationData.lastReadingTime = null;
                        notificationData.notificationTrigger = trigger;
                        notificationData.notificationTriggered = false;
                        notificationData.emails = notification.emails;

                        view.notifications.push(notificationData);
                        view.removeUntrackedUnit(unit.id);
                    } else {
                        view.errorToast();
                    }
                });
        },
        deleteNotification(notification) {
            let view = this;

            this.api.post(`delete-notification/${notification.id}`).then(function (response) {
                if (response.status == 200) {
                    view.$buefy.toast.open({
                        message: view.$t("notifications.removed"),
                        type: 'is-success'
                    });

                    view.notifications = view.notifications.filter(n => {
                        return n.id != notification.id;
                    });

                    // Make the deleted notification creatable
                    let creatableNotification = {
                        unit: notification.unit,
                        emails: notification.emails
                    }

                    view.creatableNotifications.push(creatableNotification);
                } else {
                    view.errorToast();
                }
            })
        },
        enableNotification(notification) {
            let view = this;

            this.api.post(`enable-notification/${notification.id}`).then(function (response) {
                if (response.status == 200) {
                    view.$buefy.toast.open({
                        message: view.$t("notifications.enabled"),
                        type: 'is-success'
                    });

                    notification.status = "active";
                } else {
                    view.errorToast();
                }
            })
        },
        disableNotificaion(notification) {
            let view = this;

            this.api.post(`disable-notification/${notification.id}`).then(function (response) {
                if (response.status == 200) {
                    view.$buefy.toast.open({
                        message: view.$t("notifications.disabled"),
                        type: 'is-success'
                    });

                    notification.status = "disabled";
                } else {
                    view.errorToast();
                }
            })
        },
        refreshNotification(notification) {
            let view = this;

            view.$buefy.toast.open({
                message: view.$t("notifications.startedRefresh", { unitName: formatUnitName(notification.unit) }),
                type: 'is-info'
            });

            this.api.post(`refresh-notification/${notification.id}`).then(function (response) {
                if (response.status == 200) {
                    let notificationData = response.data.notification;

                    notification.lastReading = notificationData.lastReading;
                    notification.lastReadingTime = notificationData.lastReadingTime;

                    view.$buefy.toast.open({
                        message: view.$t("notifications.updated", { unitName: formatUnitName(notification.unit) }),
                        type: 'is-success',
                        duration: 5000
                    });
                } else {
                    view.$buefy.toast.open({
                        message: view.$t("misc.genericError"),
                        type: 'is-danger'
                    });
                }
            }).catch(function (error) {
                let response = error.response;

                if (response.status == 404 && response.data.code == errorCodes.unitMissingReport) {
                    view.$buefy.toast.open({
                        message: view.$t("jobPreview.missingReport"),
                        type: 'is-danger',
                        duration: 3000
                    })
                } else {
                    view.$buefy.toast.open({
                        message: view.$t("notifications.tokenRefreshNeeded", { unitName: formatUnitName(notification.unit) }),
                        type: 'is-danger',
                        duration: 5000
                    });
                }
            })
        },
        updateNotification(notification) {
            let view = this;
            let payload = {
                trigger: notification.notificationTrigger
            }

            this.api.post(`update-notification/${notification.id}`, payload)
                .then(function (response) {
                    if (response.status == 200) {
                        view.$buefy.toast.open({
                            message: view.$t("notifications.saved"),
                            type: 'is-success'
                        });
                    } else {
                        view.errorToast();
                    }
                });
        },
        errorToast() {
            this.$buefy.toast.open({
                message: this.$t("misc.genericError"),
                type: 'is-danger'
            });
        }
    },
    mounted: function () {
        this.fetchNotifications();
    }
};

</script>

<style scoped></style>